export * from '@primeuix/themes/lara/badge';
export { default } from '@primeuix/themes/lara/badge';
